<div *ngIf="conditionalIncentiveFeatureFlagEnabled">
  <p-progressSpinner *ngIf="isLoading"></p-progressSpinner>
  <p-divider></p-divider>
  <h3>Conditional Incentives Configurator</h3>
  <tr class="p-grid form-row" title="Conditional Incentives">
    <td class="p-col-1">
      <button pButton type="button" class="p-button-success" label="Add" (click)="addIncentive()"></button>
    </td>
  </tr>
  <div [formGroup]="incentiveForm" *ngIf="isFormLoaded">
    <div formArrayName="incentives">
      <tr class="p-grid p-justify-even form-row">
        <th class="p-col-3">Group Affiliation</th>
        <th class="p-col-3">Previous Ownership</th>
        <th class="p-col-3">Incentive Application</th>
        <th class="p-col-1"></th>
      </tr>
      <div class="p-grid p-justify-center p-align-center p-justify-even form-row"
           *ngFor="let incentive of incentives.controls; let idx = index"
           [formGroupName]="idx">
        <td class="p-col-3 position-relative">
          <p-dropdown [options]="groupAffiliations"
                      formControlName="groupAffiliation"
                      placeholder="Select Group Affiliation"
                      filter="true"
                      optionLabel="name"></p-dropdown>
          <div *ngIf="incentive.get('groupAffiliation').invalid">
            <small class="invalid-text">Group Affiliation is required.</small>
          </div>
        </td>
        <td class="p-col-3 position-relative">
          <p-dropdown [options]="previousOwnerships"
                      formControlName="previousOwnership"
                      filter="true"
                      placeholder="Select Previous Ownership"
                      optionLabel="name"></p-dropdown>
          <div *ngIf="incentive.get('previousOwnership').invalid">
            <small class="invalid-text">Previous Ownership is required.</small>
          </div>
          <div *ngIf="incentive.errors?.duplicateCombination">
            <small class="invalid-text">This combination already exists.</small>
          </div>
        </td>
        <td class="p-col-3 position-relative">
          <p-dropdown [options]="applicationValues"
                      formControlName="applicationValue"
                      placeholder="Select Incentive Application"></p-dropdown>
          <div *ngIf="incentive.get('applicationValue').invalid">
            <small class="invalid-text">Application Type is required.</small>
          </div>
        </td>
        <td class="p-col-1 position-relative">
          <button pButton type="button" class="p-button-danger p-button-icon" (click)="removeIncentive(idx)">
            <i class="pi pi-trash"></i>
          </button>
        </td>
      </div>
      <tr class="p-grid p-justify-even" *ngIf="incentives.controls.length === 0">
        <div class="label-below no-incentives">No Incentive configurations created yet.</div>
      </tr>
    </div>
  </div>
</div>
